<template>
  <div class="order" v-loading="loading">
    <div class="order-first">
      <div class="order-first-center">
        <div class="first-center-list" v-for="(item, index) in 6" :key="index">
          <div class="first-center-list-title">
            {{
              index == 0
                ? '用户id'
                : index == 1
                ? '用户名称'
                : index == 2
                ? '用户电话'
                : index == 3
                ? '支付类型'
                : index == 4
                ? '订单号'
                : '订单支付时间'
            }}
          </div>

          <div class="first-center-list-input">
            <el-input
              v-if="index == 0"
              placeholder="请输入用户id"
              v-model="orderUserid"
              clearable
            ></el-input>
            <el-input
              v-if="index == 1"
              placeholder="请输入用户名称"
              v-model="orderUsername"
              clearable
            ></el-input>
            <el-input
              v-if="index == 2"
              placeholder="请输入用户电话"
              v-model="orderUserphone"
              clearable
            ></el-input>
            <el-select
              v-if="index == 3"
              v-model="orderPaymentType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in orderPaymentList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-input
              v-if="index == 4"
              placeholder="请输入订单号"
              v-model="orderOrdernum"
              clearable
            ></el-input>

            <el-date-picker
              v-if="index == 5"
              value-format="yyyy-MM-dd"
              v-model="orderOrdertake"
              type="daterange"
              range-separator
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </div>
      </div>

      <div class="order-first-bottom">
        <div class="first-bottom-inquire" @click="orderInquire">查询</div>
        <div class="first-bottom-reset" @click="orderReset">重置</div>
      </div>
    </div>

    <div class="order-second">
      <div class="order-second-div">
        <div class="order-second-div-left">查询结果</div>
        <div class="order-second-div-right">
          <div class="order-second-div-right-refresh" @click="refreshClick">
            刷新
          </div>
        </div>
      </div>

      <div class="order-second-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border=""
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column
            prop="userId"
            label="用户ID"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="用户手机号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            label="用户昵称"
            width="150"
          ></el-table-column>

          <el-table-column
            prop="vipPrice"
            label="支付金额"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="vipName"
            label="持续时间"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="orderNum"
            label="订单号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="payCode"
            label="支付单号"
            width="300"
          ></el-table-column>
          <el-table-column prop="" label="VIP状态" width="300">
            <template slot-scope="scope">
              {{
                scope.row.status == 1
                  ? '已付款'
                  : scope.row.status == 2
                  ? '已退款'
                  : ''
              }}
            </template>
          </el-table-column>

          <el-table-column prop="" label="支付方式" width="100">
            <template slot-scope="scope">
              <div class="table-paytype">
                <div class="table-paytype-title">
                  {{
                    scope.row.payType == 1
                      ? '微信支付'
                      : scope.row.payType == 2
                      ? '支付宝支付'
                      : scope.row.payType == 3
                      ? '立减券抵扣'
                      : scope.row.payType == 4
                      ? '积分支付'
                      : scope.row.payType == 5
                      ? '银盛微信'
                      : scope.row.payType == 6
                      ? '银盛支付宝'
                      : scope.row.payType == 7
                      ? '银盛网银'
                      : ''
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="开始时间"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间"
            width="200"
          ></el-table-column>

          <el-table-column prop="" label="操作" width="106" fixed="right">
            <template slot-scope="scope">
              <div class="table-operation" v-if="scope.row.status == 1">
                <div
                  class="table-operation-title"
                  @click="auditClick(scope.row)"
                >
                  审核
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="integral-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getVipOrderlist } from '../../api/order'

import Bus from '../../utils/bus'

export default {
  data() {
    return {
      // 控制当前页面功能性按钮开关
      vipFunShow: false,
      loading: false,
      orderUserid: '',
      orderUsername: '',
      orderUserphone: '',
      orderOrdernum: '',
      //  第一区域 支付方式
      orderPaymentType: '',
      orderPaymentList: [
        {
          value: 1,
          label: '微信',
        },
        {
          value: 2,
          label: '支付宝',
        },
        {
          value: 3,
          label: '立减券抵扣',
        },
        {
          value: 4,
          label: '积分支付',
        },
        {
          value: 5,
          label: '银盛微信',
        },
        {
          value: 6,
          label: '银盛支付宝',
        },
        {
          value: 7,
          label: '银盛网银',
        },
      ],
      //  第一区域 订单收货时间
      orderOrdertake: [],
      orderOrdertakeA: '',
      orderOrdertakeB: '',
      //-----
      // 第二区域 表格数组
      tableData: [],
      // 第二区域 表格总条数
      totalNum: 0,
      // 存储表格选中的值
      multipleSelection: [],
      // 页码
      page: 1,
      // 页数
      limit: 10,
    }
  },
  created() {
    this.loading = true
    setTimeout(() => {
      this.vipFunShow = this.$store.state.pageFunctionShow
    }, 1000)

    this.getOrderlistClick()
  },
  methods: {
    //------------查询重置
    orderInquire() {
      this.loading = true
      // 订单收货时间
      if (this.orderOrdertake != null && this.orderOrdertake.length != 0) {
        this.orderOrdertakeA = this.orderOrdertake[0]
        this.orderOrdertakeB = this.orderOrdertake[1]
      } else {
        this.orderOrdertakeA = ''
        this.orderOrdertakeB = ''
      }

      this.page = 1

      this.$nextTick(() => {
        this.getOrderlistClick()
      })
    },
    orderReset() {
      this.orderUserid = ''
      this.orderUsername = ''
      this.orderUserphone = ''
      this.orderPaymentType = ''
      this.orderOrdernum = ''
      this.orderOrdertake = []
      this.orderOrdertakeA = ''
      this.orderOrdertakeB = ''

      this.page = 1

      this.$nextTick(() => {
        this.getOrderlistClick()
      })
    },
    // 刷新
    refreshClick() {
      this.loading = true
      this.$nextTick(() => {
        this.getOrderlistClick()
      })
    },

    getOrderlistClick() {
      let params = {
        userId: this.orderUserid,
        userName: this.orderUsername,
        userPhone: this.orderUserphone,
        paytype: this.orderPaymentType,
        orderNum: this.orderOrdernum,
        paycode: '',
        createstartTime: this.orderOrdertakeA,
        createEndTime: this.orderOrdertakeB,
        pageSize: this.limit,
        pageNo: this.page,
      }

      getVipOrderlist(params).then((res) => {
        if (res.resultStatus == true) {
          this.tableData = res.resultData.list

          console.log('查询', this.tableData)

          // 获取总条数
          this.totalNum = res.resultData.totalNum
          // 关闭刷新
          this.loading = false
        }
      })
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getOrderlistClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getOrderlistClick()
    },

    //----------弹出框

    auditClick(item) {
      if (this.vipFunShow == false) {
        return
      }

      let obj = {
        orderId: item.payCode,
        orderIndex: 1,
      }
      Bus.$emit('log', 'afterSaledetail', obj)
    },
  },
}
</script>

<style lang="less" scoped>
.order {
  .order-first {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 24px;
    box-sizing: border-box;

    .order-first-center {
      display: flex;

      .first-center-list {
        margin-right: 22px;

        .first-center-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .first-center-list-input {
          width: 100%;
          margin-top: 4px;

          /deep/ .el-input {
            height: 32px;
            width: 180px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }

          /deep/ .el-range-editor.el-input__inner {
            padding: 0;
            padding: 0 12px;
            box-sizing: border-box;
          }

          /deep/ .el-date-editor--daterange.el-input__inner {
            width: 382px;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 26px;
            padding: 0;
            height: 32px;
            line-height: 32px;
            background-image: url('../../assets/activities/activities-right.png');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .first-center-list:last-child {
        margin-right: 0;
      }
    }

    .order-first-bottom {
      display: flex;
      margin-top: 27px;

      .first-bottom-inquire,
      .first-bottom-reset {
        width: 110px;
        height: 36px;
        background: #222222;
        border-radius: 10px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .first-bottom-reset {
        background: #f4f5f9;
        margin-left: 10px;
        color: #999999;
      }
    }
  }

  .order-second {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;
    padding: 24px;
    box-sizing: border-box;

    .order-second-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .order-second-div-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .order-second-div-right {
        display: flex;
        align-items: center;
        justify-content: center;

        .order-second-div-right-refresh {
          width: 70px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(34, 34, 34, 0.4);
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          cursor: pointer;
        }

        .order-second-div-right-derive {
          width: 110px;
          height: 36px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .order-second-div-right-derive-img {
            width: 12px;
            height: 12px;
          }

          .order-second-div-right-derive-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }

    .order-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table td.el-table__cell div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      /deep/ .el-table__cell {
        // vertical-align: top;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;

        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-img {
        height: 70px;
        background: #f0f0f0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 70px;
          height: 53px;
        }
      }

      .table-ordernum {
        .table-ordernum-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-ordernum-img {
          margin-top: 9px;
          width: 15px;
          height: 16px;
          cursor: pointer;
        }
      }

      .table-recipients {
        .table-recipients-phone {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-recipients-address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          line-height: 22px;
          margin-top: 5px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .table-user {
        .table-user-name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-user-relation {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .table-commodity {
        display: flex;
        align-content: center;
        margin-bottom: 10px;

        .table-commodity-left {
          width: 70px;
          height: 70px;
          border: 1px solid #ccc;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .table-commodity-right {
          width: 196px;
          margin-left: 12px;

          .table-commodity-right-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 22px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .table-commodity-right-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            margin-top: 4px;
          }
        }
      }

      .table-commodity:last-child {
        margin-bottom: 0;
      }

      .table-commodityPrice {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        margin-bottom: 4px;
      }

      .table-commodityPrice:last-child {
        margin-bottom: 0;
      }

      .table-paytype {
        .table-paytype-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-paytype-img {
          width: 34px;
          height: 34px;
          margin-top: 7px;
        }
      }

      .table-operation {
        display: flex;
        align-items: center;

        .table-operation-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-logistics {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .integral-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>
